// Phase 19 S0 — client route guard for admin surfaces.
//
// The REAL enforcement is server-side (RLS + is_strikza_admin()); a
// non-admin who bypasses this guard sees empty data, not a leak.
// This is the UX layer: don't render admin chrome to non-admins.
// The founder uid lives ONLY in the SQL function — this calls the
// is_strikza_admin() RPC, never hardcodes an id client-side.

import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { getBrowserClient } from "../../supabase/browser.ts";

type Gate = "checking" | "allowed" | "denied";

export function AdminOnly(
  { children }: { children: React.ReactNode },
): JSX.Element {
  const [gate, setGate] = useState<Gate>("checking");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const client = getBrowserClient();
        const { data, error } = await (client.rpc as unknown as (
          fn: string,
        ) => Promise<{ data: unknown; error: unknown }>)(
          "is_strikza_admin",
        );
        if (cancelled) return;
        setGate(!error && data === true ? "allowed" : "denied");
      } catch {
        if (!cancelled) setGate("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (gate === "checking") {
    return (
      <div
        data-testid="admin-gate-checking"
        style={{
          padding: "48px 28px",
          fontFamily: "var(--se-font-mono, monospace)",
          fontSize: 12,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          color: "var(--se-text-muted, #888)",
        }}
      >
        Verifying access…
      </div>
    );
  }
  if (gate === "denied") {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}
